export default "__VITE_ASSET__B_n1ndpr__"